import { MyAsyncStorage, readParam, serviceKey } from "./helper";
import { createContext, useState, useEffect, useRef } from "react";
import axios, { AxiosError } from "axios";

import qs from "qs";

import { BASE_URL } from "../config";
import ActivityScreen from "../screens/activityscreen";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [userToken, setUserToken] = useState(null);
  const [selectFirm, setSelectFirm] = useState(false);
  const [changePassW, setChangePassW] = useState(false);

  const [isService, setIsService] = useState(false);
  const [isCustomerRequest, setIsCustomerRequest] = useState(false);
  const [serviceBoardInfo, setServiceBoardInfo] = useState();

  const userInfo = useRef(null);
  const useFirm = useRef(0);
  const useFirmName = useRef("");

  const notifyToken = useRef("");
  const tokenIsRegistered = useRef(false);

  /*   const urlParams = new URLSearchParams(window.location.search);
  const myParam = urlParams.get('token');
 */

  const getServiceInfo = async (token) => {
    setIsLoading(true);
    const url = `${BASE_URL}/getservicedata`;
    let data = {
      action: "getboardinfo",
      token: token,
    };
    let options = {
      method: "POST",
      headers: {
        "content-type": "application/x-www-form-urlencoded",
        servicekey: serviceKey,
      },
      data: qs.stringify(data),
      url,
    };
    await axios(options)
      .then((res) => {
        console.log(new Date(res.data.data.producedate).getTime());

        setServiceBoardInfo(res.data.data);
      })
      .catch((e) => {
        console.log(`Get Boardinfo error ${e}`);
      });
    setIsService(true);
    setIsLoading(false);
  };

  const setNotifyToken = (token) => {
    notifyToken.current = token;

    if (userInfo.current) {
      // Register Token
      registerNotifyToken(token, userInfo.current.userid, useFirm.current);
      tokenIsRegistered.current = true;
    }
  };

  const registerNotifyToken = async (token, userid, firmid, utoken = null) => {
    if (utoken === null) utoken = userToken;
    const url = `${BASE_URL}/getdata`;
    let data = {
      action: "registernotifytoken",
      token: token,
      userid: userid,
      firmid: firmid,
    };
    let options = {
      method: "POST",
      headers: {
        "content-type": "application/x-www-form-urlencoded",
        Authorization: "Bearer " + utoken,
      },
      data: qs.stringify(data),
      url,
    };
    await axios(options)
      .then((res) => {
        //console.log("Token register");
        //console.log(res.data);
      })
      .catch((e) => {
        console.log(`Token register error ${e}`);
      });
  };

  const login = async (username, password, isservice = false, firmid = 0) => {
    return new Promise(async (resolve, reject) => {
      setIsLoading(true);

      const url = `${BASE_URL}/oauth/1.0/token`;
      let data = {
        client_id: username,
        client_secret: password,
        isservice: isservice ? 1 : 0,
        firmid: firmid,
      };
      let options = {
        method: "POST",
        headers: {
          "content-type": "application/x-www-form-urlencoded",
        },
        data: qs.stringify(data),
        url,
      };
      axios(options)
        .then((res) => {
          //console.log(res);
          let _userInfo = res.data;
          let _useFirm = 0;
          let _useFirmName = "";
          if (!isservice && (_userInfo.R_Admin || _userInfo.R_Manager)) {
            setSelectFirm(true);
          } else {
            _useFirm = _userInfo.firmid;
            _useFirmName = _userInfo.firmname;
          }

          useFirm.current = _useFirm;
          useFirmName.current = _useFirmName;
          userInfo.current = _userInfo;
          if (!isservice) setChangePassW(_userInfo.changepassword);
          setUserToken(_userInfo.token);

          if (!isservice) {
            //console.log(_userInfo.token);
            MyAsyncStorage.SetJSON("userInfo", _userInfo);
            MyAsyncStorage.SetString("userToken", _userInfo.token);
            if (_userInfo.R_Admin || _userInfo.R_Manager) {
              MyAsyncStorage.SetInt("useFirm", _useFirm);
              MyAsyncStorage.SetString("useFirmName", _useFirmName);
            }

            if (notifyToken.current && !tokenIsRegistered.current && _useFirm)
              registerNotifyToken(
                notifyToken.current,
                _userInfo.userid,
                _useFirm,
                _userInfo.token
              );
          }

          resolve({ result: "OK", reason: "" });
          //console.log(userInfo);
          //console.log('User Token: '+userInfo.token);
        })
        .catch((e) => {
          console.log(`Login error ${e}`);
          reject({
            result: "Failed",
            code: e.response ? e.response.status : 500,
            reason: e.response ? e.response.data : `${e}`,
          });
        });

      setIsLoading(false);
    });
  };

  const logout = () => {
    setIsLoading(true);
    useFirm.current = 0;
    useFirmName.current = "";
    userInfo.current = "";
    setUserToken(null);
    MyAsyncStorage.RemoveItem("userInfo");
    MyAsyncStorage.RemoveItem("userToken");
    MyAsyncStorage.RemoveItem("useFirm");
    MyAsyncStorage.RemoveItem("useFirmName");

    if (notifyToken.current) registerNotifyToken(notifyToken.current, 0, 0);

    tokenIsRegistered.current = false;

    setIsLoading(false);
  };

  const isLoggedIn = async () => {
    try {
      setIsLoading(true);
      let _userToken = await MyAsyncStorage.GetString("userToken");
      let _userInfo = await MyAsyncStorage.GetJSON("userInfo");
      let _useFirm = await MyAsyncStorage.GetInt("useFirm");
      let _useFirmName = await MyAsyncStorage.GetString("useFirmName");

      if (_userToken) {
        const url = `${BASE_URL}/login`;
        let options = {
          method: "POST",
          headers: {
            "content-type": "application/x-www-form-urlencoded",
            Authorization: "Bearer " + _userToken,
          },
          url,
        };
        await axios(options)
          .then((res) => {
            //console.log(res.data);
            _userInfo = res.data;
            if (_userInfo && _userInfo.login == "OK") {
              setChangePassW(_userInfo.changepassword);
              setUserToken(_userToken);
              userInfo.current = _userInfo;
              //setUserInfo(_userInfo);
              if (_userInfo.R_Admin || _userInfo.R_Manager) {
                useFirm.current = _useFirm;
                //setUseFirm(_useFirm);
                useFirmName.current = _useFirmName;
                //setUseFirmName(_useFirmName);
                if (_useFirm === 0) setSelectFirm(true);
              } else {
                _useFirm = _userInfo.firmid;
                _useFirmName = _userInfo.firmname;
                useFirm.current = _useFirm;
                //setUseFirm(_useFirm);
                useFirmName.current = _useFirmName;
                //setUseFirmName(_useFirmName);
              }

              MyAsyncStorage.SetJSON("userInfo", _userInfo);

              //console.log(userInfo);
              //console.log('User Token: '+userInfo.token);

              if (notifyToken.current && !tokenIsRegistered.current && _useFirm)
                registerNotifyToken(
                  notifyToken.current,
                  _userInfo.userid,
                  _useFirm,
                  _userToken
                );
            } else {
              MyAsyncStorage.RemoveItem("userInfo");
              MyAsyncStorage.RemoveItem("userToken");
              MyAsyncStorage.RemoveItem("useFirm");
              MyAsyncStorage.RemoveItem("useFirmName");
            }
          })
          .catch((reason) => {
            console.log(`${reason}`);
            if ([401, 404].indexOf(reason.response.status) !== -1) {
              console.log(reason.response.data);
              MyAsyncStorage.RemoveItem("userInfo");
              MyAsyncStorage.RemoveItem("userToken");
              MyAsyncStorage.RemoveItem("useFirm");
              MyAsyncStorage.RemoveItem("useFirmName");
            } else {
              console.log(_userInfo);
              userInfo.current = _userInfo;
              //setUserInfo(_userInfo);
              useFirm.current = (_userInfo.R_Admin || _userInfo.R_Manager) ? _useFirm : _userInfo.firmid;
              //setUseFirm(_userInfo.R_Admin?_useFirm:_userInfo.firmid);
              useFirmName.current = _useFirmName;
              //setUseFirmName(_useFirmName);
              setUserToken(_userToken);
            }
          });
      }
      setIsLoading(false);
    } catch (e) {
      console.log(`isLogged in error ${e}`);
    }
  };

  const changePassword = async (oldPassword, newPassword) => {
    return new Promise(async (resolve, reject) => {
      const url = `${BASE_URL}/getdata`;
      let data = {
        action: "changepassword",
        oldpassword: oldPassword,
        newpassword: newPassword,
      };
      let options = {
        method: "POST",
        headers: {
          "content-type": "application/x-www-form-urlencoded",
          Authorization: "Bearer " + userToken,
        },
        data: qs.stringify(data),
        url,
      };
      await axios(options)
        .then((res) => {
          //console.log(res);
          let _data = res.data;
          if (_data && _data.result == "OK") {
            let _newtoken = _data.data.newtoken;
            userInfo.current.changepassword = false;
            MyAsyncStorage.SetJSON("userInfo", userInfo.current);
            MyAsyncStorage.SetString("userToken", _newtoken);
            setUserToken(_newtoken);
            setChangePassW(false);
            resolve({ result: "OK", reason: "" });
          } else if (_data && _data.result == "Failed")
            console.log(`Change Password error: ${_data.reason}`);
          reject({ result: "Failed", code: 200, reason: "" });
        })
        .catch((e) => {
          //console.log(e);
          console.log(`Change Password error ${e}`);
          reject({
            result: "Failed",
            code: e.response ? e.response.status : 500,
            reason: e.response ? e.response.data : `${e}`,
          });
        });
    });
  };

  const changeFirm = (firmid = 0, firmname = "") => {
    if (firmid === 0) {
      useFirm.current = 0;
      //setUseFirm(0);
      useFirmName.current = "";
      //setUseFirmName("");
      setSelectFirm(true);
      MyAsyncStorage.RemoveItem("useFirm");
      MyAsyncStorage.RemoveItem("useFirmName");

      if (notifyToken.current) registerNotifyToken(notifyToken.current, 0, 0);
    } else {
      useFirm.current = firmid;
      //setUseFirm(firmid);
      useFirmName.current = firmname;
      //setUseFirmName(firmname);
      setSelectFirm(false);
      MyAsyncStorage.SetInt("useFirm", firmid);
      MyAsyncStorage.SetString("useFirmName", firmname);

      if (notifyToken.current)
        registerNotifyToken(
          notifyToken.current,
          userInfo.current.userid,
          firmid
        );
    }
  };

  useEffect(() => {
    const { service, token, customerrequest } = readParam(["service", "token", "customerrequest"]);
/*             const { service, token } = {
      service: "true",
      //token: "34360F2400364BE48351292232023C58",
      token: "5D159744A50F42AFADA0F911864F3536",
    };
 */   
    //console.log(`Service: ${service} - Token: ${token}`);
    if (service === "true") getServiceInfo(token);
    else if (customerrequest === "true") setIsCustomerRequest(true);
    else isLoggedIn();
  }, []);

  if (isLoading) {
    return (
      <ActivityScreen />
    );
  }

  return (
    <AuthContext.Provider
      value={{
        login,
        logout,
        changePassword,
        changeFirm,
        setNotifyToken,
        setServiceBoardInfo,
        isLoading,
        userToken,
        userInfo,
        selectFirm,
        changePassW,
        useFirm,
        useFirmName,
        notifyToken,
        isService,
        isCustomerRequest,
        serviceBoardInfo,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
